import { Toast } from 'vant';
import alipay from './alipay';

function isWxBrowser() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return !!userAgent.match(/micromessenger/);
}

function isAlipayBrowser() {
    if (window.ap && window.ap.isAlipay) return true;
    const userAgent = window.navigator.userAgent.toLowerCase();
    return !!userAgent.match(/alipayclient/);
}

function login() {
    const { apiUrlRoot } = window.$MIDE_CONFIG;
    const returnUrl = encodeURIComponent(window.location.href);
    if (isWxBrowser()) {
        window.location.href = `${apiUrlRoot}/api/login?returnUrl=${returnUrl}`;
    } else if (isAlipayBrowser()) {
        alipay.getAuthCode().then((authCode) => {
            window.location.href = `${apiUrlRoot}/api/login?authCode=${authCode}&returnUrl=${returnUrl}`;
        });
    } else {
        Toast.fail('请用微信或支付宝打开');
    }
}

export default {
    isWxBrowser,
    isAlipayBrowser,
    login,
};
